// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"c7e4d78a","403":"4cde7a41","468":"a9c8cbf0","629":"ae6f5e3f"}[chunkId] + ".chunk.js";
};